export interface DeviceShape {
  id: string
  label: string
  /** Container CSS size in CSS pixels. */
  width: number
  height: number
  /** Placeholder rect (CSS px, relative to the canvas) this preset should apply, matching its documented chart size. */
  placeholderRect: { left: number; top: number; width: number; height: number }
}

/**
 * Compact portrait, normal portrait, and landscape boundaries used by the
 * mobile layout validation matrix (see spec `mobile-chart-iframe-validation`
 * and task 4.1's 320x240 / 360x300 / 390x400 / 667x300 rectangles).
 */
export const DEVICE_SHAPES: DeviceShape[] = [
  {
    id: 'compact-portrait',
    label: 'Compact portrait (320x240 chart)',
    width: 360,
    height: 640,
    placeholderRect: { left: 20, top: 80, width: 320, height: 240 },
  },
  {
    id: 'normal-portrait',
    label: 'Normal portrait (360x300 chart)',
    width: 390,
    height: 844,
    placeholderRect: { left: 15, top: 100, width: 360, height: 300 },
  },
  {
    id: 'normal-portrait-tall',
    label: 'Normal portrait, taller (390x400 chart)',
    width: 390,
    height: 844,
    placeholderRect: { left: 0, top: 100, width: 390, height: 400 },
  },
  {
    id: 'landscape',
    label: 'Landscape (667x300 chart)',
    width: 844,
    height: 390,
    placeholderRect: { left: 20, top: 45, width: 667, height: 300 },
  },
]

export const FRAMEBUFFER_SCALES = [1, 2, 3]
